import type { JSX } from 'react';
import type { BoxDimensions } from '@/types/BoundingBox.types';

interface BoundingBoxHandlesProps {
  scaledBox: BoxDimensions;
  cornerLength?: number;
  cornerRadius?: number;
  strokeWidth?: number;
  className?: string;
}

const BoundingBoxHandles = ({
  scaledBox,
  cornerLength = 15,
  cornerRadius = 8,
  strokeWidth = 3,
  className,
}: BoundingBoxHandlesProps): JSX.Element => {
  return (
    <svg
      className={className}
      style={{
        left: `${scaledBox.x}px`,
        top: `${scaledBox.y}px`,
        width: `${scaledBox.width}px`,
        height: `${scaledBox.height}px`,
      }}
    >
      <path
        d={`M ${cornerLength} 0
   L ${cornerRadius} 0
   Q 0 0, 0 ${cornerRadius}
   L 0 ${cornerLength}`}
        stroke="white"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <path
        d={`M ${scaledBox.width - cornerLength} 0
   L ${scaledBox.width - cornerRadius} 0
   Q ${scaledBox.width} 0, ${scaledBox.width} ${cornerRadius}
   L ${scaledBox.width} ${cornerLength}`}
        stroke="white"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <path
        d={`M 0 ${scaledBox.height - cornerLength}
   L 0 ${scaledBox.height - cornerRadius}
   Q 0 ${scaledBox.height}, ${cornerRadius} ${scaledBox.height}
   L ${cornerLength} ${scaledBox.height}`}
        stroke="white"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <path
        d={`M ${scaledBox.width} ${scaledBox.height - cornerLength}
   L ${scaledBox.width} ${scaledBox.height - cornerRadius}
   Q ${scaledBox.width} ${scaledBox.height}, ${
     scaledBox.width - cornerRadius
   } ${scaledBox.height}
   L ${scaledBox.width - cornerLength} ${scaledBox.height}`}
        stroke="white"
        strokeWidth={strokeWidth}
        fill="none"
      />
    </svg>
  );
};

export default BoundingBoxHandles;
